import React, { useEffect, useState } from "react";
import polyline from "@mapbox/polyline";
import Map from "./Map";

export default function Home({ selectedAthlete, showEvent, showTraining }) {
  const [routes, setRoutes] = useState(null);

  useEffect(() => {
    // check if we have a ?code= in the URL (Strava callback)
    // then upsert athlete and remove ?code= from URL
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/strava/callback`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ code })
      })
        .then(r => r.json())
        .then(data => {
          window.location.href = `/onboarding/${data.athleteId}`;
        });
    }


    fetch(`${process.env.REACT_APP_BACKEND_URL}/activities`)
      .then(r => r.json())
      .then(data => {
        const mapped = data.map(a => ({
          id: a.activityId,
          name: a.name,
          displayName: a.athleteId?.displayName || a.athleteId?.name || "Onbekende atleet",
          firstName: a.athleteId?.firstName || "Onbekende atleet",
          lastName: a.athleteId?.lastName || "Onbekende atleet",
          description: a.description,
          date: a.date,
          distance: a.distance,
          duration: a.moving_time,
          athlete: a.athleteId?.name || "Onbekende atleet",
          points: polyline.decode(a.summary_polyline)
        }));

        setRoutes(mapped);
      });
  }, []);

  return (
    <div>
      <h1>Hartekind routes</h1>
      <Map routes={routes}
        selectedAthlete={selectedAthlete}
        showEvent={showEvent}
        showTraining={showTraining} />
      {/* {routes && routes.length > 0 && <Map routes={routes} />}
      {(!routes || routes.length === 0) && <p>Er zijn nog geen routes beschikbaar.</p>} */}
    </div>
  );
}